import axios from "axios";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import jsPDF from "jspdf";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ListAbsenGuru = () => {
  const token = localStorage.getItem("token");

  const [absensi, setAbsensi] = useState([]);
  const [summary, setSummary] = useState(null);

  const [tahunList, setTahunList] = useState([]);
  const [semesterList, setSemesterList] = useState([]);

  const [tahun, setTahun] = useState("");
  const [semester, setSemester] = useState("");

  const [loading, setLoading] = useState(true);

  const [dataKepsek, setDataKepsek] = useState([]);
  const [schoolData, setSchoolData] = useState([]);

  // ================= DETAIL STATE =================
  const [selectedGuru, setSelectedGuru] = useState(null);
  const [detailData, setDetailData] = useState([]);

  // ==========================================
  // FETCH INITIAL DATA
  // ==========================================
  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const token = localStorage.getItem("token");

        const [schoolRes, kepsekRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}api/datasekolah/all`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(
            `${process.env.REACT_APP_API_URL}api/auth/user-images-and-roles`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          ),
        ]);

        setSchoolData(schoolRes.data);
        setDataKepsek(
          kepsekRes.data.filter((user) => user.jabatan === "Kepala Sekolah"),
        );
      } catch (err) {
        console.error("Gagal mengambil data:", err);
      }
    };

    fetchAll();
  }, []);
  const today = new Date();
  const formattedDate = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const handleDownloadPDF = () => {
    if (guruNames.length === 0) {
      alert("Tidak ada data untuk didownload");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");

    let startX = 14;
    let startY = 30;
    let rowHeight = 8;

    const colWidths = {
      no: 15,
      nama: 75,
      sakit: 25,
      izin: 25,
      tanpa: 30,
    };

    const tableWidth =
      colWidths.no +
      colWidths.nama +
      colWidths.sakit +
      colWidths.izin +
      colWidths.tanpa;

    // ======================
    // JUDUL
    // ======================
    doc.setFontSize(14);
    doc.text("REKAP ABSENSI GURU", 105, 15, { align: "center" });

    doc.setFontSize(11);
    doc.text(`Tahun: ${tahun}   Semester: ${semester}`, 105, 22, {
      align: "center",
    });

    // ======================
    // HEADER
    // ======================
    let x = startX;
    let y = startY;

    doc.rect(startX, y, tableWidth, rowHeight);

    doc.text("No", x + 5, y + 5);
    x += colWidths.no;

    doc.line(x, y, x, y + rowHeight);
    doc.text("Nama Guru", x + 5, y + 5);
    x += colWidths.nama;

    doc.line(x, y, x, y + rowHeight);
    doc.text("Sakit", x + 8, y + 5);
    x += colWidths.sakit;

    doc.line(x, y, x, y + rowHeight);
    doc.text("Izin", x + 10, y + 5);
    x += colWidths.izin;

    doc.line(x, y, x, y + rowHeight);
    doc.text("Tanpa Ket.", x + 3, y + 5);

    y += rowHeight;

    // ======================
    // DATA
    // ======================
    guruNames.forEach((nama, index) => {
      if (y > 270) {
        doc.addPage();
        y = 20;
      }

      x = startX;

      doc.rect(startX, y, tableWidth, rowHeight);

      doc.text(String(index + 1), x + 5, y + 5);
      x += colWidths.no;

      doc.line(x, y, x, y + rowHeight);
      doc.text(nama, x + 3, y + 5);
      x += colWidths.nama;

      doc.line(x, y, x, y + rowHeight);
      doc.text(String(guruMap[nama].sakit), x + 10, y + 5);
      x += colWidths.sakit;

      doc.line(x, y, x, y + rowHeight);
      doc.text(String(guruMap[nama].izin), x + 10, y + 5);
      x += colWidths.izin;

      doc.line(x, y, x, y + rowHeight);
      doc.text(String(guruMap[nama].tanpaKeterangan), x + 10, y + 5);

      y += rowHeight;
    });

    // ======================
    // TOTAL
    // ======================
    const totalSakit = guruNames.reduce((acc, g) => acc + guruMap[g].sakit, 0);

    const totalIzin = guruNames.reduce((acc, g) => acc + guruMap[g].izin, 0);

    const totalTanpa = guruNames.reduce(
      (acc, g) => acc + guruMap[g].tanpaKeterangan,
      0,
    );

    x = startX;

    doc.rect(startX, y, tableWidth, rowHeight);

    doc.text("", x + 5, y + 5);
    x += colWidths.no;

    doc.line(x, y, x, y + rowHeight);
    doc.text("TOTAL", x + 3, y + 5);
    x += colWidths.nama;

    doc.line(x, y, x, y + rowHeight);
    doc.text(String(totalSakit), x + 10, y + 5);
    x += colWidths.sakit;

    doc.line(x, y, x, y + rowHeight);
    doc.text(String(totalIzin), x + 10, y + 5);
    x += colWidths.izin;

    doc.line(x, y, x, y + rowHeight);
    doc.text(String(totalTanpa), x + 10, y + 5);
    // ======================
    // TANDA TANGAN
    // ======================

    y += 15;

    if (y > 250) {
      doc.addPage();
      y = 20;
    }

    const ttdX = 130;

    // Tempat & tanggal
    doc.text(`${schoolData[0]?.ttDsekolah || ""}, ${formattedDate}`, ttdX, y);

    y += 7;

    // Jabatan
    doc.text("Kepala Sekolah", ttdX, y);

    y += 20;

    // Nama Kepsek
    const namaKepsek = dataKepsek[0]?.name || "";
    doc.text(namaKepsek, ttdX, y);

    // ===== GARIS BAWAH OTOMATIS SESUAI PANJANG NAMA =====
    const textWidth = doc.getTextWidth(namaKepsek);

    doc.line(
      ttdX, // x1
      y + 1, // y1 (sedikit di bawah teks)
      ttdX + textWidth, // x2 (panjang sesuai teks)
      y + 1, // y2
    );

    y += 6;

    // NIP
    doc.text(`NIP. ${dataKepsek[0]?.NIP || ""}`, ttdX, y);

    doc.save(`Rekap_Absensi_Guru_${tahun}_Semester_${semester}.pdf`);
  };

  // ================= EDIT STATE =================
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({
    id: "",
    tahun: "",
    semester: "",
    tanggal: "",
    guru: [],
  });

  const handleOpenEdit = () => {
    if (absensi.length === 0) return;

    const firstData = absensi[0]; // ambil data pertama (bisa diganti sesuai kebutuhan)

    setEditData({
      id: firstData._id,
      tahun: firstData.tahun,
      semester: firstData.semester,
      tanggal: firstData.tanggal,
      guru: firstData.guru,
    });

    setShowEditModal(true);
  };

  const handleGuruChange = (index, field, value) => {
    const updatedGuru = [...editData.guru];
    updatedGuru[index][field] = value;

    setEditData({
      ...editData,
      guru: updatedGuru,
    });
  };

  const handleSaveEdit = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}api/absensiguru/${editData.id}`,
        editData,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      alert("Data berhasil diupdate");
      setShowEditModal(false);
      fetchFilteredData();
    } catch (err) {
      console.error(err);
      alert("Gagal update data");
    }
  };

  const handleCariEdit = async () => {
    try {
      // ambil semua data dulu (pakai endpoint GET ALL)
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const allData = res.data;

      // filter di frontend
      const filtered = allData.find(
        (item) =>
          item.tahun === editData.tahun &&
          item.semester === editData.semester &&
          new Date(item.tanggal).toISOString().split("T")[0] ===
            editData.tanggal,
      );

      if (!filtered) {
        alert("Data tidak ditemukan");
        return;
      }

      // set data ke form edit
      setEditData({
        id: filtered._id,
        tahun: filtered.tahun,
        semester: filtered.semester,
        tanggal: filtered.tanggal.split("T")[0],
        guru: filtered.guru,
      });
    } catch (err) {
      console.error(err);
      alert("Gagal mencari data");
    }
  };

  useEffect(() => {
    if (tahun && semester) {
      fetchFilteredData();
    }
  }, [tahun, semester]);

  const fetchInitialData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = res.data;
      setAbsensi(data);

      const uniqueTahun = [...new Set(data.map((item) => item.tahun))].sort(
        (a, b) => b.localeCompare(a),
      );
      setTahunList(uniqueTahun);
      if (uniqueTahun.length > 0) setTahun(uniqueTahun[0]);

      const uniqueSemester = [...new Set(data.map((item) => item.semester))];
      setSemesterList(uniqueSemester);
      if (uniqueSemester.length > 0) setSemester(uniqueSemester[0]);
    } catch (err) {
      console.error(err);
      alert("Gagal mengambil data");
    } finally {
      setLoading(false);
    }
  };

  const fetchFilteredData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru?tahun=${tahun}&semester=${semester}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const sum = await axios.get(
        `${process.env.REACT_APP_API_URL}api/absensiguru/summary?tahun=${tahun}&semester=${semester}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setAbsensi(res.data);
      setSummary(sum.data);
    } catch (err) {
      console.error(err);
      alert("Gagal mengambil data filter");
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  // HITUNG REKAP PER GURU
  // ==========================================
  const guruMap = {};

  absensi.forEach((item) => {
    item.guru.forEach((g) => {
      if (!guruMap[g.namaGuru]) {
        guruMap[g.namaGuru] = {
          sakit: 0,
          izin: 0,
          tanpaKeterangan: 0,
        };
      }

      guruMap[g.namaGuru].sakit += g.sakit;
      guruMap[g.namaGuru].izin += g.izin;
      guruMap[g.namaGuru].tanpaKeterangan += g.tanpaKeterangan;
    });
  });

  const guruNames = Object.keys(guruMap);

  // ==========================================
  // HANDLE DETAIL
  // ==========================================
  const handleDetail = (namaGuru) => {
    setSelectedGuru(namaGuru);

    const filtered = [];

    absensi.forEach((item) => {
      item.guru.forEach((g) => {
        if (
          g.namaGuru === namaGuru &&
          (g.sakit > 0 || g.izin > 0 || g.tanpaKeterangan > 0)
        ) {
          filtered.push({
            tanggal: item.tanggal,
            sakit: g.sakit,
            izin: g.izin,
            tanpaKeterangan: g.tanpaKeterangan,
            keterangan: g.keterangan || "-",
          });
        }
      });
    });

    setDetailData(filtered);
  };

  // ==========================================
  // CHART TOTAL
  // ==========================================
  const totalChart = {
    labels: ["Sakit", "Izin", "Tanpa Keterangan"],
    datasets: [
      {
        label: "Total",
        data: summary
          ? [
              summary.totalSakit,
              summary.totalIzin,
              summary.totalTanpaKeterangan,
            ]
          : [0, 0, 0],
        backgroundColor: ["#facc15", "#3b82f6", "#ef4444"],
      },
    ],
  };

  // ==========================================
  // CHART PER GURU
  // ==========================================
  const perGuruChart = {
    labels: guruNames,
    datasets: [
      {
        label: "Sakit",
        data: guruNames.map((g) => guruMap[g].sakit),
        backgroundColor: "#facc15",
      },
      {
        label: "Izin",
        data: guruNames.map((g) => guruMap[g].izin),
        backgroundColor: "#3b82f6",
      },
      {
        label: "Tanpa Keterangan",
        data: guruNames.map((g) => guruMap[g].tanpaKeterangan),
        backgroundColor: "#ef4444",
      },
    ],
  };

  if (loading) return <div className="p-10">Loading data...</div>;

  return (
    <div className="p-8">
      <div className="mb-4">
        <button
          onClick={handleOpenEdit}
          className="bg-yellow-500 text-white px-4 py-2 rounded"
        >
          EDIT DATA ABSENSI
        </button>
      </div>
      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center pt-20">
          <div className="bg-white p-6 rounded w-[800px] max-h-[70vh] overflow-auto">
            <h2 className="text-xl font-bold mb-4">Edit Absensi</h2>

            <div className="grid grid-cols-4 gap-4 mb-4">
              <input
                type="text"
                value={editData.tahun}
                onChange={(e) =>
                  setEditData({ ...editData, tahun: e.target.value })
                }
                className="border p-2 rounded"
                placeholder="Tahun"
              />

              <input
                type="text"
                value={editData.semester}
                onChange={(e) =>
                  setEditData({ ...editData, semester: e.target.value })
                }
                className="border p-2 rounded"
                placeholder="Semester"
              />

              <input
                type="date"
                value={editData.tanggal}
                onChange={(e) =>
                  setEditData({ ...editData, tanggal: e.target.value })
                }
                className="border p-2 rounded"
              />

              {/* BUTTON CARI */}
              <button
                onClick={handleCariEdit}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Cari
              </button>
            </div>

            <table className="w-full border mb-4">
              <thead className="bg-gray-200">
                <tr>
                  <th className="border p-2">Nama Guru</th>
                  <th className="border p-2">Sakit</th>
                  <th className="border p-2">Izin</th>
                  <th className="border p-2">Tanpa Keterangan</th>
                  <th className="border p-2">Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {editData.guru.map((g, index) => (
                  <tr key={index}>
                    <td className="border p-2">{g.namaGuru}</td>
                    <td className="border p-2">
                      <input
                        type="number"
                        value={g.sakit}
                        onChange={(e) =>
                          handleGuruChange(
                            index,
                            "sakit",
                            Number(e.target.value),
                          )
                        }
                        className="border p-1 w-full"
                      />
                    </td>
                    <td className="border p-2">
                      <input
                        type="number"
                        value={g.izin}
                        onChange={(e) =>
                          handleGuruChange(
                            index,
                            "izin",
                            Number(e.target.value),
                          )
                        }
                        className="border p-1 w-full"
                      />
                    </td>
                    <td className="border p-2">
                      <input
                        type="number"
                        value={g.tanpaKeterangan}
                        onChange={(e) =>
                          handleGuruChange(
                            index,
                            "tanpaKeterangan",
                            Number(e.target.value),
                          )
                        }
                        className="border p-1 w-full"
                      />
                    </td>
                    <td className="border p-2">
                      <input
                        type="text"
                        value={g.keterangan || ""}
                        onChange={(e) =>
                          handleGuruChange(index, "keterangan", e.target.value)
                        }
                        className="border p-1 w-full"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowEditModal(false)}
                className="bg-gray-500 text-white px-4 py-2 rounded"
              >
                Batal
              </button>

              <button
                onClick={handleSaveEdit}
                className="bg-green-600 text-white px-4 py-2 rounded"
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      )}
      <h1 className="text-2xl font-bold mb-6">Rekap Absensi Staff dan Guru</h1>

      {/* FILTER */}
      <div className="flex gap-4 mb-6">
        <select
          value={tahun}
          onChange={(e) => setTahun(e.target.value)}
          className="border p-2 rounded"
        >
          {tahunList.map((t, index) => (
            <option key={index} value={t}>
              {t}
            </option>
          ))}
        </select>

        <select
          value={semester}
          onChange={(e) => setSemester(e.target.value)}
          className="border p-2 rounded"
        >
          {semesterList.map((s, index) => (
            <option key={index} value={s}>
              Semester {s}
            </option>
          ))}
        </select>
      </div>

      {/* GRAFIK TOTAL */}
      <div className="mb-10">
        <h2 className="font-semibold mb-2">Grafik Total</h2>
        <Bar data={totalChart} />
      </div>

      {/* GRAFIK PER GURU */}
      <div className="mb-10">
        <h2 className="font-semibold mb-2">Grafik Per Staff atau Guru</h2>
        <Bar data={perGuruChart} />
      </div>

      {/* TABEL */}
      <div>
        <h2 className="font-semibold mb-2">Tabel Rekap Staff dan Guru</h2>

        <div className="overflow-auto">
          <table className="w-full border">
            <thead className="bg-gray-200">
              <tr>
                <th className="border p-2">Nama Guru</th>
                <th className="border p-2">Sakit</th>
                <th className="border p-2">Izin</th>
                <th className="border p-2">Tanpa Keterangan</th>
                <th className="border p-2">Detail</th>
              </tr>
            </thead>
            <tbody>
              {guruNames.map((g, index) => (
                <tr key={index}>
                  <td className="border p-2">{g}</td>
                  <td className="border p-2 text-center">{guruMap[g].sakit}</td>
                  <td className="border p-2 text-center">{guruMap[g].izin}</td>
                  <td className="border p-2 text-center">
                    {guruMap[g].tanpaKeterangan}
                  </td>
                  <td className="border p-2 text-center">
                    <button
                      onClick={() => handleDetail(g)}
                      className="bg-blue-600 text-white px-3 py-1 rounded"
                    >
                      Detail
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <button
        onClick={handleDownloadPDF}
        className="bg-red-600 text-white px-4 py-2 rounded"
      >
        Download PDF
      </button>

      {/* MODAL DETAIL */}
      {selectedGuru && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="bg-white p-6 rounded w-[600px] max-h-[80vh] overflow-auto">
            <h2 className="text-xl font-bold mb-4">
              Detail Absensi: {selectedGuru}
            </h2>

            {detailData.length === 0 ? (
              <p>Tidak ada data izin/sakit/tanpa keterangan</p>
            ) : (
              <table className="w-full border">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border p-2">Tanggal</th>
                    <th className="border p-2">Sakit</th>
                    <th className="border p-2">Izin</th>
                    <th className="border p-2">Tanpa Keterangan</th>
                    <th className="border p-2">Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  {detailData.map((d, i) => (
                    <tr key={i}>
                      <td className="border p-2">
                        {new Date(d.tanggal).toLocaleDateString("id-ID")}
                      </td>
                      <td className="border p-2 text-center">{d.sakit}</td>
                      <td className="border p-2 text-center">{d.izin}</td>
                      <td className="border p-2 text-center">
                        {d.tanpaKeterangan}
                      </td>
                      <td className="border p-2">{d.keterangan}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            <div className="text-right mt-4">
              <button
                onClick={() => setSelectedGuru(null)}
                className="bg-red-600 text-white px-4 py-2 rounded"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListAbsenGuru;
